import './SearchPanel.scss';
import Component from './SearchPanel.js';
export default Component;
